export default {
  eyebrow: 'Partner portal',
  title: 'Billing',
  description: 'Your payment method for the monthly platform invoice, and every invoice with its full breakdown.',
  toasts: {
    checkout_error: 'Could not start the checkout — please try again.',
    action_error: 'The action failed — please try again.',
    onboarding_error: 'Could not start the verification — please try again.',
    payment_method_in_use:
      'Your restaurant licences are billed to this payment method, so it cannot be removed. Replace it with a new one instead.',
  },
  payout_bank_account: {
    title: 'Payout bank account',
    description: 'Revenue-share payouts arrive in {{currency}}. Stripe converts the transfer when it arrives.',
    toasts: {
      saved: 'Bank account saved',
      save_failed: "We couldn't save the bank account. Please check the details.",
    },
  },
  payout_onboarding: {
    title: 'Set up your payout account',
    description:
      'Your revenue share is paid out monthly to a Stripe payout account. Complete the verification once — payouts stay on hold until it is done.',
    missing: {
      title: 'Still needed before payouts can start:',
      bank_account: 'Add the bank account your revenue share should be paid out to.',
      business_details: 'Complete your company details, such as address, tax ID or registration number.',
      people: 'Add the details of your company representative, owners or directors.',
      documents: 'Upload the verification documents Stripe has asked for.',
      terms: 'Accept the Stripe terms of service.',
      other: 'Provide the remaining details Stripe has asked for.',
    },
    start: 'Start verification',
    continue: 'Continue verification',
    ready: 'Payout account verified — your revenue share is paid out automatically after each billing cycle.',
  },
  payment_method: {
    title: 'Payment method',
    empty: 'No payment method on file — the monthly invoice cannot be collected automatically yet.',
    add: 'Add payment method',
    replace: 'Replace',
    remove: 'Remove',
    remove_confirm: {
      title: 'Remove this payment method?',
      description:
        'The card/mandate is detached from Stripe immediately. Without a payment method, invoices — including any already issued — are collected via the hosted Stripe invoice instead of automatically.',
      confirm: 'Remove',
    },
  },
  invoices: {
    title: 'Invoices',
  },
};
